import React, { useState } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  CircularProgress,
  Grid,
  TextField,
  Drawer,
} from "@mui/material";
import PaginationComp from "../../Pagination/PaginationComp";

const SubMerchantTable = ({
  merchant,
  message,
  page,
  totalPage,
  setPage,
  loading,
}) => {
  return (
    <>
      <div
        style={{
          maxHeight: "calc(100vh - 180px)",
          overflowY: "auto",
          marginTop: "16px",
          position: "relative",
        }}
      >
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            my={3}
          >
            <CircularProgress sx={{ color: "#ff6600" }} />
          </Box>
        ) : (
          <Table
            stickyHeader
            sx={{
              mt: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
              "& th, & td": {
                padding: "10px 12px",
                fontSize: "13.5px",
              },
            }}
          >
            <TableHead
              sx={{
                backgroundColor: "#f1f5f9",
                position: "sticky",
                top: 0,
                zIndex: 1,
                "& th": {
                  fontWeight: 600,
                  color: "#1f2937",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  borderBottom: "1px solid #e0e0e0",
                  backgroundColor: "#f1f5f9",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableRow>
                {[
                  "Sub Merchant",
                  "Status",
                  "Web Payment",
                  "Created On",
                  "Action",
                ].map((heading) => (
                  <TableCell key={heading}>
                    <Typography variant="h6">{heading}</Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {merchant.map((merchant, index) => (
                <TableRow
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                    "&:hover": {
                      backgroundColor: "#f1f1f1",
                    },
                  }}
                >
                  <TableCell>
                    <Typography variant="h6">
                      <span style={{ color: "#ff9800" }}>
                        MER. No.: ({merchant.id}) {merchant.name}
                      </span>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6">
                      {merchant.status === 1 ? (
                        <span style={{ color: "green" }}>Active</span>
                      ) : (
                        <span style={{ color: "red" }}>Inactive</span>
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6">
                      {merchant.allow_webpayment === 1 ? (
                        <span style={{ color: "green" }}>Enabled</span>
                      ) : (
                        <span style={{ color: "red" }}>Disabled</span>
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6">{merchant.created_on}</Typography>
                  </TableCell>
                  <TableCell>
                    <ViewDrawer item={merchant} />
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={12} align="center"></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </div>
      <PaginationComp
        setPage={setPage}
        page={page}
        totalPage={totalPage}
        message={message}
        disabled={loading}
      />
    </>
  );
};

const ViewDrawer = ({ item }) => {
  const [state, setState] = useState({ right: false });

  const toggleDrawer = (open) => () => {
    setState({ right: open });
    if (open) {
      // console.log(item);
    } else {
      // window.location.reload();
    }
  };

  return (
    <div>
      <button className="btn btn-secondary btn-sm" onClick={toggleDrawer(true)}>
        View
      </button>
      <Drawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer(false)}
        PaperProps={{ style: { zIndex: 3 } }}
      >
        <Box role="presentation" sx={{ width: { xs: 300, sm: 500 } }}>
          <div style={{ padding: "20px", position: "relative" }}>
            <h4>TRANSACTION DETAILS</h4>
            <button
              style={{
                position: "absolute",
                top: "22px",
                right: "10px",
                background: "#ff6600",
                border: "none",
                borderRadius: "50%",
                cursor: "pointer",
                padding: "5px",
                width: "25px",
                height: "25px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={toggleDrawer(false)}
            >
              <svg
                xmlns="http://www .org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x"
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <Grid container spacing={2}>
              {[
                { label: "NAME.", value: item?.name || "NOT AVAILABLE" },
                {
                  label: "EMAIL",
                  value: item?.email || "NOT AVAILABLE",
                },
                { label: "MOBILE", value: item?.mobile_no || "NOT AVAILABLE" },
                {
                  label: "BUSINESS NAME",
                  value: item?.bname || "NOT AVAILABLE",
                },
                { label: "BUSINESS LOCATION", value: item?.blocation || "NOT AVAILABLE" },
                { label: "JOB TITLE", value: item?.job_title || "NOT AVAILABLE" },
                { label: "WEBSITE", value: item?.website || "NOT AVAILABLE" },
                { label: "ANNUAL PROCESSING VOLUME", value: item?.apv || "NOT AVAILABLE" },
                {
                  label: "AVAERAGE TRANSACTION AMOUNT",
                  value: item?.ata || "NOT AVAILABLE",
                },
                { label: "CHAREGBACK PERCENTAGE", value: item?.charge_back_per || "NOT AVAILABLE" },
                {
                  label: "SETTLED CURRENCY",
                  value: item?.settle_currency || "NOT AVAILABLE",
                },
                {
                  label: "SOLUTION APPLY COUNTRIES",
                  value: item?.solution_country_names || "NOT AVAILABLE",
                },
                {
                  label: "PAYOUT COUNTRIES",
                  value: item?.payout_country_names || "NOT AVAILABLE",
                },
              ].map((field, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <TextField
                    label={field.label}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={field.value}
                    InputProps={{ readOnly: true, style: { zIndex: 4 } }}
                    disabled
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </Box>
      </Drawer>
    </div>
  );
};

export default SubMerchantTable;
